import AddNew from "./AddNew";
class None extends React.Component {
    render(page = this.props.page) {
        let classText;
        if( page === "my_post" || page === "post"){
            if(LANG['Kuulutused']){
                classText = LANG['Kuulutused']
            } else {
                classText = 'Kuulutused'
            }
        } else {
            if(LANG['Oksjonid']){
                classText = LANG['Oksjonid']
            } else {
                classText = 'Oksjonid'
            }
        }
        return(

            <section className={'none-found'}>
                <h2>{classText} {LANG['puuduvad'] || 'puuduvad'}</h2>
                <AddNew page={page}/>
            </section>
        )}
}

export default None;